//Core
import React from "react"

//Styles
import "./index.scss"

const LightSpinner = ({ color }) => {
  return (
    <div className="spinner-box">
      <div className="circle-border">
        <div
          className="circle-core"
          css={color ? { backgroundColor: color } : {}}
        ></div>
      </div>
    </div>
  )
}

export default LightSpinner
